import React, { useEffect, useState } from 'react'
import { notification, Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import FilteringDropdown from './filteringDropdown';
import CopyPastePopup from './copyPastePopup';
import { getDistinctValues } from '../../utilities/utilFunctions';
import YearRangeModal from './yearDropdown';
//import '../../style.css'


function QueryBuilder({ title, filters, requiredFilters, getFilteredOptions, runQuery, controlsDisabled }) {
    const [searchValue, setSearchValue] = useState();
    const [activeTab, setActiveTab] = useState('');
    const [notificationApi, contextHolder] = notification.useNotification({ maxCount: 1 });
    const [isYearModalOpen, setIsYearModalOpen] = useState(false);

    const constructOptionsObj = () => {
        const obj = {}
        filters.forEach(filter => obj[filter] = []);
        return obj;
    }
    const [options, setOptions] = useState(() => constructOptionsObj());
    const [selectedOptions, setSelectedOptions] = useState(() => constructOptionsObj());
    const [filtering, setFiltering] = useState(false);

    const applyFilters = (tab) => {
        setFiltering(true);
        const { modifiedOptions, modifiedSelectedOptions } = getFilteredOptions(tab, selectedOptions);
        setOptions({ ...options, ...modifiedOptions });
        setSelectedOptions({ ...selectedOptions, ...modifiedSelectedOptions });
        setFiltering(false);
    }
    const handleYearRange = () => {
        setIsYearModalOpen(true);
    };

    useEffect(() => {
        if (filters[0] !== undefined) {
            setActiveTab(filters[0])
            applyFilters(filters[0])
        }
    }, [])


    const handleClear = () => {
        setSelectedOptions({ ...selectedOptions, [activeTab]: [] })
    }


    const onSelectAll = () => {
        const optionsToSelect = options[activeTab].filter(option =>
            option.label.toLowerCase().includes(searchValue.toLowerCase())
        ).map(option => option.value);

        // Update the selected options for the active tab
        let newSelectedOptions = selectedOptions[activeTab].concat(optionsToSelect);
        newSelectedOptions = getDistinctValues(newSelectedOptions);
        setSelectedOptions({ ...selectedOptions, [activeTab]: newSelectedOptions });
        setSearchValue('')
    };

    const onTabChange = async (e) => {
        setActiveTab(e.target.name);
        applyFilters(e.target.name);
        setSearchValue('')
    }

    const submitQuery = () => {
        setFiltering(true);
        const { modifiedOptions, modifiedSelectedOptions } = getFilteredOptions('ALL', selectedOptions);
        setOptions({ ...options, ...modifiedOptions });
        setSelectedOptions({ ...selectedOptions, ...modifiedSelectedOptions });
        setFiltering(false);
        runQuery({ ...selectedOptions, ...modifiedSelectedOptions });
    }
    const handleYearRangeSubmit = ({ startYear, endYear }) => {
    const start = parseInt(startYear);
    const end = parseInt(endYear);

    const yearsInRange = options['Years']
        .map(y => parseInt(y.value))
        .filter(y => y >= start && y <= end)
        .map(String);

    setSelectedOptions(prev => ({
        ...prev,
        Years: yearsInRange
    }));
};

    return (
        <>
            {contextHolder}
            <div className="row">
                <div className="mb-3 px-3 pb-1 pt-2 bg-body rounded shadow">
                    <div className="row">
                        <h5>{title}</h5>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        {/* Tabs Component */}
                                        <ul className="nav nav-tabs card-header-tabs" data-bs-tabs="tabs">
                                            {filters.length > 0 && filters.map((filter, i) => {
                                                return (
                                                    <li key={i} className={`nav-item ${activeTab === filter ? 'active' : ''}`}>
                                                        <button name={filter}
                                                            style={{color: '#2e6ac1'}}
                                                            className={`nav-link ${activeTab === filter ? 'active' : ''}`}
                                                            onClick={onTabChange}
                                                            disabled={controlsDisabled || filtering}>
                                                            {requiredFilters.includes(filter) ? `${filter}*` : filter}
                                                        </button>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                    {/* Query Button Component */}
                                    <div className="col-2" style={{ width: '120px' }}>
                                        <button className="btn btn-primary btn-sm"
                                            onClick={submitQuery}
                                            disabled={!requiredFilters.every(filter => selectedOptions[filter].length > 0)}
                                            style={{ width: '100px', height: '25px', border: 'none', marginTop: '6px', backgroundColor: "transparent", color: "#2e6ac1" }}>
                                            <FontAwesomeIcon icon={faPlay} />&nbsp;Run Query</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body tab-content">
                            <div className="tab-pane active" id={`${activeTab}`}>
                                <div style={{ display: "flex", alignItems: "top" }}>
                                    <FilteringDropdown
                                        name={activeTab}
                                        options={options[activeTab]}
                                        selectedOptions={selectedOptions[activeTab]}
                                        disabled={controlsDisabled || filtering}
                                        setSelectedOptions={(options) => setSelectedOptions({ ...selectedOptions, [activeTab]: options })}
                                        setSearchValue={setSearchValue}
                                    />
                                    {activeTab ==='Years'? 
                                    <Button style={{ marginLeft: '4px' }} onClick={handleYearRange} disabled={controlsDisabled}>
                                        Select Year Range
                                    </Button> :null
                                    }
                                    <YearRangeModal
                                        visible={isYearModalOpen}
                                        onClose={() => setIsYearModalOpen(false)}
                                        options={options['Years'] || []}
                                        onSubmit={handleYearRangeSubmit}
                                    />
                                    <Button style={{ marginLeft: '4px' }} onClick={handleClear} disabled={controlsDisabled}>
                                        Clear
                                    </Button>
                                    &nbsp;
                                    <CopyPastePopup
                                        selectedOptions={selectedOptions[activeTab]}
                                        options={options[activeTab]}
                                        setSelectedOptions={(options) => setSelectedOptions({ ...selectedOptions, [activeTab]: options })}
                                        col={activeTab}
                                        disabled={controlsDisabled || filtering}
                                    ></CopyPastePopup>
                                    {/* Pass additional information with filters to determine if a filter should use this button or not ?? */}
                                    {activeTab === 'Experiments' ? <Button style={{ marginLeft: '4px' }} onClick={onSelectAll} disabled={controlsDisabled} >
                                        Select All or Select Similar
                                    </Button> : ''}
                                </div>
                            </div>

                        </div>

                    </div>
                    <div style={{fontSize:'13px', float:'right', padding:'4px', color: '#6a6a6a'}}>* - required filter</div>
                </div>
            </div>
        </>)









} export default QueryBuilder;